import { ReactElement } from "react";
import { Tabs } from "antd";
import type { TabsProps } from "antd";

import "./tabs-component.scss";
import { EllipsisOutlined } from "@ant-design/icons";

interface TabsComponentProps {
  items: TabsProps["items"];
  activeTab?: string;
  onChange?: (activeKey: string) => void;
}

const TabsComponent: React.FC<TabsComponentProps> = ({
  items,
  activeTab,
  onChange,
}: TabsComponentProps): ReactElement => {
  return (
    <div className="tabs-container">
      <Tabs
        activeKey={activeTab}
        items={items}
        onChange={onChange}
        // destroyInactiveTabPane
        moreIcon={<EllipsisOutlined className="text-2xl font-bold" />}
        renderTabBar={(props, TabNavList) => (
          <TabNavList {...props} mobile={false} />
        )}
        centered={true}
        size="large"
        // tabBarStyle={{
        //   width: '100%'
        // }}
      />
    </div>
  );
};

export default TabsComponent;
